// removed by extract-text-webpack-plugin
module.exports = {"default":"_1k-7U","red":"_3HY1A"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Helpers/StyledText/StyledTextComponents/Link.scss
 ** module id = 432
 ** module chunks = 0
 **/